import {EventEmitter, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {REQUEST_OPTIONS} from '../../app.constants';
import {PaySerie} from '../../models/models.interfaces';
import {ApiService} from '../api';
import {Headers} from '../utils/headers';
import {isBlank} from '../utils/lang';
import {QueryParamBuilder} from '../utils/query-param-builder';

@Injectable()
export class ChartService {

  public series: Array<any> = [];
  public seriesLoaded: EventEmitter<any> = new EventEmitter<any>();

  constructor(private api: ApiService) {
  }

  public getPaySerieStatistics(): Observable<any> {
    return this.api.get('/payroll/api/v1/reporting/paySerieStatistics', REQUEST_OPTIONS.OBSERVE.RESPONSE)
      .pipe(
        map(response => {
          this.series = response.body;
          return {
            payload: response.body,
            total: parseInt(Headers.get(response.headers, 'X-Total-Count'), 10)
          };
        })
      );
  }

  public getPaySeries(
    {
      perPage,
      page,
      appendSeries = false,
      orderBy
    }: {
      perPage?: number,
      page?: number,
      appendSeries?: boolean,
      orderBy?: string
    }
  ): Observable<{ total: number, payload: PaySerie[] }> {
    const builder = new QueryParamBuilder('/payroll/api/v1/pay-serie');
    if (perPage) {
      builder.add('per-page', perPage);
    }
    if (!isBlank(page)) {
      builder.add('page', page);
    }
    if (orderBy) {
      builder.add('order-by', orderBy);
    }

    return this.api.get(builder.build(), REQUEST_OPTIONS.OBSERVE.RESPONSE)
      .pipe(
        map(response => {
          const newSeries = response.body.map(paySerie => <PaySerie>paySerie);
          this.setNewSeries(newSeries, appendSeries);
          return {
            payload: this.series,
            total: parseInt(Headers.get(response.headers, 'X-Total-Count'), 10)
          };
        })
      );
  }

  private setNewSeries(newSeries, appendSeries: boolean) {
    if (appendSeries) {
      this.series.push(...newSeries);
    } else {
      this.series = newSeries;
    }
  }
}
